// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1bjDA","containerItemsCenter":"Skeleton_containerItemsCenter__2R_BC"};